import { LogInForm } from './LogInForm';

export const LogIn = () => {

  return (
    <div className='min-vh-100 d-md-flex flex-column justify-content-center'>
      <div>
        <a
          className='sidebar__logo mx-auto mb-5'
          style={{ width: '316px', height: '120px' }}
          href={import.meta.env.VITE_WP_URL}
        />
      </div>
      <div>
        <LogInForm />
      </div>
    </div>
  );
};

export default LogIn;

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/components/form.scss to add styles
